import Card from 'react-bootstrap/Card'
import { Fragment } from 'react'
import { OutboundLink } from 'react-ga'
import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'
import classNames from 'classnames'
import empty from '../assets/empty.png'
import styles from '../styles/ArticlePreview.module.scss'
import useDarkMode from 'use-dark-mode'

const ArticlePreview = ({
  author,
  date,
  excerpt,
  isLoading,
  link,
  media,
  small,
  site,
  tags,
  title,
}) => {
  const darkMode = useDarkMode(false)
  let authorName = author?.name
  if (site && site.id !== 'edhrec') {
    authorName += ` — ${site.name}`
  }
  if (!link) return null
  return (
    <div
      className={classNames(styles.container, {
        [styles.dark]: darkMode.value,
      })}
    >
      <Card className={classNames('shadow-sm', styles.card)}>
        <OutboundLink eventLabel={link} target='_blank' to={link}>
          <Card.Img
            className={classNames(styles.media, { [styles.mediaSmall]: small })}
            variant='top'
            src={isLoading ? empty : media}
          />
        </OutboundLink>
        <Card.Body className={styles.cardBody}>
          <div>
            {isLoading ? (
              <div
                className={classNames(styles.avatar, {
                  [styles.avatarSmall]: small,
                })}
              >
                <img alt='Loading' src={empty} />
              </div>
            ) : author ? (
              <OutboundLink
                eventLabel={author.link}
                target='_blank'
                to={author.link}
              >
                <div
                  className={classNames(styles.avatar, {
                    [styles.avatarSmall]: small,
                  })}
                >
                  <img alt={author.name} src={author.avatar} />
                </div>
              </OutboundLink>
            ) : null}
            <div className={styles.row}>
              <div className={styles.date}>
                {isLoading ? <Skeleton /> : date}
              </div>
              <div className={styles.author}>
                {isLoading ? (
                  <Skeleton />
                ) : author ? (
                  <OutboundLink
                    dangerouslySetInnerHTML={{ __html: authorName }}
                    eventLabel={link}
                    target='_blank'
                    to={author.link}
                  />
                ) : null}
              </div>
            </div>
            <h5 className={styles.title}>
              {isLoading ? (
                <Skeleton count={2} />
              ) : (
                <OutboundLink eventLabel={link} target='_blank' to={link}>
                  {title}
                </OutboundLink>
              )}
            </h5>
            <div
              className={classNames(styles.excerpt, {
                [styles.excerptSmall]: small,
              })}
            >
              {isLoading ? <Skeleton count={2} /> : excerpt}
            </div>
          </div>
          {tags?.length > 0 && (
            <div>
              <hr />
              <div className={styles.tags}>
                {tags.map(({ link, name }, i) => (
                  <Fragment key={link}>
                    <OutboundLink eventLabel={link} target='_blank' to={link}>
                      {`#${name}`}
                    </OutboundLink>
                    {i !== tags.length - 1 && ', '}
                  </Fragment>
                ))}
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  )
}

ArticlePreview.propTypes = {
  author: PropTypes.shape({
    avatar: PropTypes.string,
    link: PropTypes.string,
    name: PropTypes.string,
  }),
  date: PropTypes.string,
  excerpt: PropTypes.string,
  isLoading: PropTypes.bool,
  link: PropTypes.string,
  media: PropTypes.string,
  small: PropTypes.bool,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  title: PropTypes.string,
}

export default ArticlePreview
